// src/pages/support/components/TeamCard.jsx
import React from "react";
import StatusBadge from "./StatusBadge";
import MemberRow from "./MemberRow";

function TeamCard({ 
  team, 
  onEdit, 
  onChangeCaptain, 
  onDelete, 
  onDeactivate, 
  onDeactivatePlayer, 
  onRollbackTransfer,
  onAddInstrument // 👈 اضافه شد
}) {
  const members = Array.isArray(team.members) ? team.members : [];
  const borderColor = team.color || "#10b981";
  const isTeamActive = (team.status || "").toLowerCase() === "active";

  return (
    <div
      className="rounded-2xl border overflow-hidden group"
      style={{ borderColor: borderColor, background: "rgba(17,24,39,0.7)" }}
    >
      {/* ... header بدون تغییر ... */}
      <div
        className="flex items-center justify-between p-5 border-b"
        style={{ borderColor: "rgba(55,65,81,0.5)", background: "rgba(31,41,55,0.65)" }}
      >
        <div className="flex items-center gap-4">
          <div className="w-14 h-14 rounded-xl overflow-hidden ring-1 ring-white/10 bg-white/5 flex items-center justify-center">
            {team.logo_path ? (
              <img
                src={`/${team.logo_path}`}
                alt={team.name}
                className="w-full h-full object-cover"
                onError={(e) => (e.currentTarget.style.display = "none")}
              />
            ) : (
              <span className="text-white/80 text-xl font-bold">
                {(team.name?.[0] || "ت")}
              </span>
            )}
          </div>
          <div>
            <div className="flex items-center gap-2">
              <h3 className="text-white font-bold text-lg">{team.name || "بدون‌نام"}</h3>
              <StatusBadge status={team.status} />
            </div>
            <div className="text-xs text-gray-400 mt-1 flex gap-3 flex-wrap">
              <span>امتیاز: <span className="text-gray-200 font-semibold">{team.points ?? 0}</span></span>
              <span>اعضا: <span className="text-gray-200 font-semibold">{members.length}</span></span>
              {"captain_changes_count" in team && (
                <span>تغییر کاپیتان: <span className="text-gray-200 font-semibold">{team.captain_changes_count ?? 0}</span></span>
              )}
            </div>
          </div>
        </div>

        <div className="flex items-center gap-2">
          <button
            onClick={onChangeCaptain}
            className="px-3 py-2 rounded-lg text-sm text-white hover:opacity-90"
            style={{ backgroundColor: "#0ea5e9" }}
          >
            تغییر کاپیتان
          </button>
          {isTeamActive && (
            <button
              onClick={onDeactivate}
              className="px-3 py-2 rounded-lg text-sm text-white hover:opacity-90"
              style={{ backgroundColor: "#f59e0b" }}
              title="غیرفعال کردن تیم"
            >
              غیرفعال
            </button>
          )}
          <button
            onClick={onEdit}
            className="px-3 py-2 rounded-lg text-sm text-white hover:opacity-90"
            style={{ backgroundColor: "#10b981" }}
          >
            ویرایش
          </button>
          <button
            onClick={onDelete}
            className="px-3 py-2 rounded-lg text-sm text-white hover:opacity-90"
            style={{ backgroundColor: "#ef4444" }}
            title="حذف تیم"
          >
            حذف
          </button>
        </div>
      </div>

      <div className="p-5 space-y-3" style={{ backgroundColor: "rgba(17,24,39,0.6)" }}>
        {members.length === 0 ? (
          <div
            className="rounded-xl p-6 border text-center"
            style={{ borderColor: "rgba(55,65,81,0.5)", backgroundColor: "rgba(31,41,55,0.55)" }}
          >
            <p className="text-gray-300">عضوی برای این تیم ثبت نشده است.</p>
          </div>
        ) : (
          members.map((m) => (
            <MemberRow 
              key={m.id} 
              member={m}
              onDeactivatePlayer={onDeactivatePlayer}
              onRollbackTransfer={onRollbackTransfer}
              onAddInstrument={(userId, username) => 
                onAddInstrument(team.id, userId, username) // 👈 teamId رو هم پاس می‌دیم
              }
            />
          ))
        )}
      </div>
    </div>
  );
}

export default TeamCard;